import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles, useTheme } from "@mui/styles";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import Chip from "@mui/material/Chip";

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: '8px',
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: '24px',
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiselectCheckbox(props) {
  const {
    inputTitle,
    selected,
    list,
    handleChange,
    primary,
    specialWidth,
    isRequired,
    disabled,
    disabledAll,
    width,
    chipsMod,
  } = props;

  const classes = useStyles();

  const isAllSelected = list.length > 0 && selected.length === list.length;

  const getSelectValues = (selection) => {
    return list
      .filter((obj) => selection.map((s) => s.id).includes(obj.id))
      .map((record) => record.name)
      .join(", ");
  };

  const getChips = (selected) => (
    <div className={classes.chips}>
      {selected.map((value) => (
        <Chip key={value.id} label={value.name} className={classes.chip} />
      ))}
    </div>
  );

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      style={{ width: width }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <InputLabel id={`${inputTitle}-checkboxes-tags-label`}>
        {inputTitle}
      </InputLabel>
      <Select
        labelId={`${inputTitle}-checkboxes-tags-label`}
        id={`${inputTitle}-checkboxes-tags`}
        multiple
        value={selected}
        onChange={handleChange}
        input={<Input />}
        renderValue={chipsMod ? getChips : getSelectValues}
        MenuProps={MenuProps}
      >
        {disabledAll ?? (
          <MenuItem
            value="all"
            classes={{
              root: isAllSelected ? classes.selectedAll : "",
            }}
          >
            <ListItemIcon>
              <Checkbox
                classes={{ indeterminate: classes.indeterminateColor }}
                checked={isAllSelected}
                indeterminate={
                  selected.length > 0 && selected.length < list.length
                }
              />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.selectAllText }}
              primary={primary}
            />
          </MenuItem>
        )}

        {list.map((option) => (
          <MenuItem key={option?.id} value={option?.id}>
            <Checkbox
              checked={selected.map((s) => s.id).indexOf(option?.id) > -1}
              style={{
                color: "#3E8FC6",
              }}
            />
            <ListItemText primary={option?.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

MultiselectCheckbox.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  isMultiple: true,
};

MultiselectCheckbox.propTypes = {
  isMultiple: PropTypes.bool,
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
};
